function sliderHeight() {
  var announcementBarHeight_S = $(".shopify-section-announcement-bar").outerHeight(true) || 0;
  var headerHeight_s = $(".main_header").outerHeight(true);
  var windowwidth_s = $(window).width();
  if(windowwidth_s < 768) {
    var totalHeight_s = announcementBarHeight_S + headerHeight_s + 20;
  }
  else
  {
    var totalHeight_s = announcementBarHeight_S + headerHeight_s + 40;
  }
  $(".nss_collection_latest_main_new").css("padding-top", totalHeight_s + "px");
  $(".nss_collection_latest_mainsides_new").css("top", headerHeight_s + "px");
}
sliderHeight();
$(window).on("resize", sliderHeight);

$(window).on('load', function() {
  if($(".nss_collection_latest_mainsides_new").length > 0)
  {
    var headerHeight_s = $(".main_header").outerHeight(true);
    var stickyHeaderTopSticky = $(".nss_collection_latest_mainsides_new").offset().top - headerHeight_s;
    $(window).scroll(function(){
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("fixed_collection_new") == false)
          {
              $('body').addClass('fixed_collection_new');
          }
      } else {
          $('body').removeClass('fixed_collection_new');
      }
    });
  }
})

if($(".collection_page_scroll_new").length > 0)
{
  // Add active class on scroll
  $(window).on("scroll", function() {
      var scrollPosition = $(window).scrollTop();
      $(".collection_page_scroll_new").each(function() {
          var width = $(window).width();

          var announcementBarHeight_S = $(".shopify-section-announcement-bar").outerHeight(true) || 0;
          var headerHeight_s = $(".main_header").outerHeight(true);
          var windowwidth_s = $(window).width();
          if(windowwidth_s < 768) {
            var totalHeight_s = announcementBarHeight_S + headerHeight_s + 90;
          }
          else
          {
            var totalHeight_s = announcementBarHeight_S + headerHeight_s + 90;
          }

          var sectionTop = $(this).offset().top - totalHeight_s;
          var sectionBottom = sectionTop + $(this).outerHeight();
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              var currentId = $(this).attr("id");
              $(".nss_collection_latest_innersides_innerloops_mainblock_new a").removeClass("active");
              $(".nss_collection_latest_innersides_innerloops_mainblock_new a[href='#" + currentId + "']").addClass("active");
          }
      });
  });
}

/* nss_collection_latest_slider */
function collectionHandlesSlider() {

$(".nss_collection_latest_innersides_innerloops_mainblock_new a").click(function (e) {
  $(".nss_collection_latest_innersides_innerloops_mainblock_new a").removeClass("active");
  $(this).addClass("active");

  var announcementBarHeight_S = $(".shopify-section-announcement-bar").outerHeight(true) || 0;
  var headerHeight_s = $(".main_header").outerHeight(true);
  var windowwidth_s = $(window).width();
  if(windowwidth_s < 750) {
    var totalHeight_s = announcementBarHeight_S + headerHeight_s + 70;
  }
  else
  {
    var totalHeight_s = announcementBarHeight_S + headerHeight_s + 70;
  }

  var href = $(this).attr("href"),
  targetHash = this.hash,
  offsetTop = $(href).offset().top - totalHeight_s;
  $('html, body').animate({
    scrollTop: offsetTop 
  },1000);
  window.location.hash = targetHash;
  e.preventDefault();
});

new Swiper('.nss_collection_latest_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 20,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    0: {
      spaceBetween: 15,
    },
    768: {
      spaceBetween: 15,
    },
    990: {
      spaceBetween: 20,
    },
    1440: {
    }
  }
})
}
collectionHandlesSlider();
document.addEventListener('collectionHandlesSlider:init', collectionHandlesSlider)

/* nss_collection_gallery_slider */
function nssCollectionLatestSliderinit(){
  new Swiper('.nss_collection_gallery_slider', {
    loop: true,
    grabCursor: false,
    spaceBetween: 20,
    slidesPerGroup: 1,
    slidesPerView: 5,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    centeredSlides: false,
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      990: {
        slidesPerView: 4
      },
      1300: {
        slidesPerView: 5
      }
    }
  })
}
nssCollectionLatestSliderinit()
document.addEventListener('nssCollectionLatestSlider:init',nssCollectionLatestSliderinit)

/* Play Video */
$(".play_icon_new").click(function(){
  if($(this).hasClass("active") == false)
  {
    $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
    $(this).parents(".video_play_list").find('video').trigger('pause');
    $(this).parents(".video_play_list").find(".play_icon").css("display","block");
    
    $(this).addClass("active");
    var URL = $(this).find('video').attr("video_url");
    if($(this).find('video').attr("src") == null)
    {
      $(this).find('video').attr("src",URL);
    }
    $(this).find('video').trigger('play');
    $(this).siblings().find('video').trigger('pause');
    $(this).siblings().find('.play_icon').css("display","block");
    $(this).find(".play_icon").css("display","none");
  }
  else
  {
    $(this).removeClass("active");
    $(this).find('video').trigger('pause');
    $(this).find(".play_icon").css("display","block");
  }
})

// js to find and replace product on shop all page for byob and ultimate sampler 

document.addEventListener('DOMContentLoaded', () => {
  console.log('[Best Sellers Exact Title Swap] Loaded');

  const section = document.querySelector('#best-sellers-handle');
  if (!section) return;

  function normalizeText(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function walkTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;

    while ((node = walker.nextNode())) {
      const text = normalizeText(node.nodeValue);
      if (!text) continue;

      if (
        text === 'Liquid Water Enhancer 10 Pack' ||
        text === 'Ultimate Sampler'
      ) {
        textNodes.push(node);
      }
    }

    return textNodes;
  }

  function swapTitles() {
    const matches = walkTextNodes(section);
    console.log('[Best Sellers Exact Title Swap] Matching text nodes:', matches.length);

    let changed = 0;

    matches.forEach((node) => {
      const text = normalizeText(node.nodeValue);

      if (text === 'Liquid Water Enhancer 10 Pack') {
        node.nodeValue = 'Build Your Own Bundle - 10-Pack';
        changed++;
      }

      if (text === 'Ultimate Sampler') {
        node.nodeValue = 'Ultimate Sampler - 10-Pack';
        changed++;
      }
    });

    console.log('[Best Sellers Exact Title Swap] Changed count:', changed);
    return changed;
  }

  const changed = swapTitles();

  if (changed < 2) {
    const observer = new MutationObserver(() => {
      if (swapTitles() >= 2) observer.disconnect();
    });

    observer.observe(section, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
});